module.exports = __webpack_public_path__ + "static/index/img/baikal-601.65253ae4.jpg";